var mobileSearchIcon = $('#mobileSearchIcon'),
    mobileSearchInput = $('#mobileSearch');

jQuery(mobileSearchIcon).on('click touchstart', function(event){

  $(mobileSearchInput).focus();

});
